/* eslint-disable no-use-before-define */
import { createSlice } from "@reduxjs/toolkit";
import { simpleSetPayload } from "../constants";

const initialState = {
  allSelfPractices: [],
  selectedSelfPractice: {},
};

export const selfPracticeSlice = createSlice({
  name: "students",
  initialState,
  reducers: {
    setAllSelfPractices: simpleSetPayload("allSelfPractices"),
    setSelectedSelfPractice: simpleSetPayload("selectedSelfPractice"),
  },
});
export default selfPracticeSlice.reducer;

// Actions

export const {
  setAllSelfPractices, setSelectedSelfPractice,
} = selfPracticeSlice.actions;
